export const SET_PARTNERS_LIST = 'partners/SET_PARTNERS_LIST'
